import {
  RECORD_LIQUIDATION_ERRORS,
  GET_RECORD_LIQUIDATION,
  GET_RECORD_LIQUIDATION_COIN,
  GET_RECORD_LIQUIDATION_PAYMENT_SITUATION,
  POST_RECORD_LIQUIDATION,
  CLEAN_STATE
} from '../types'
import client from '../../lib/api-client'
import {
  API_GESTION_CASES_RECEIVE,
  API_RECORD_LIQUIDATION,
  API_RECORD_LIQUIDATION_COIN
} from '../../lib/constants'

export const getCBCoin = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_RECORD_LIQUIDATION_COIN}?q=${q}`)
    dispatch({
      type: GET_RECORD_LIQUIDATION_COIN,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: RECORD_LIQUIDATION_ERRORS,
      payload: console.log(e)
    })
  }
}

export const getCBPaymentSituation = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_GESTION_CASES_RECEIVE}?q=${q}`)
    dispatch({
      type: GET_RECORD_LIQUIDATION_PAYMENT_SITUATION,
      payload: res.data.object
    })
  } catch (e) {
    dispatch({
      type: RECORD_LIQUIDATION_ERRORS,
      payload: console.log(e)
    })
  }
}

export const getRecordLiquidation = (query) => async (dispatch) => {
  const q = Buffer.from(JSON.stringify(query)).toString('base64')
  try {
    const res = await client.get(`${API_RECORD_LIQUIDATION}?q=${q}`)
    dispatch({
      type: GET_RECORD_LIQUIDATION,
      payload: res.data.object ? res.data.object : res.data.message
    })
  } catch (e) {
    dispatch({
      type: RECORD_LIQUIDATION_ERRORS,
      payload: console.log(e)
    })
  }
}

export const postRecordLiquidation = (body) => async (dispatch) => {
  try {
    const res = await client.post(`${API_RECORD_LIQUIDATION}`, body)
    dispatch({
      type: POST_RECORD_LIQUIDATION,
      payload: res.data.message
    })
  } catch (e) {
    dispatch({
      type: RECORD_LIQUIDATION_ERRORS,
      payload: console.log(e)
    })
  }
}

export const cleanState = () => async (dispatch) => {
  dispatch({
    type: CLEAN_STATE,
    payload: []
  })
}
